import { createContext, useContext, useState } from "react";
import { translations } from "@/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("poh-lang") || "it");

  const setLanguage = (l) => {
    setLang(l);
    localStorage.setItem("poh-lang", l);
  };

  const toggle = () => {
    setLanguage(lang === "it" ? "en" : "it");
  };

  const t = (path) => {
    const parts = path.split(".");
    let cur = translations[lang];
    for (const p of parts) {
      if (cur == null) return path;
      cur = cur[p];
    }
    return cur == null ? path : cur;
  };

  return (
    <LanguageContext.Provider value={{ lang, toggle, setLang: setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  return useContext(LanguageContext);
}
